import axios from 'axios'

const state = {
    paths: {
        mfa:          '/api/otp-auth/mfa/',
        enroll_token: '/api/otp-auth/enroll/token/',
        enroll_invite: '/api/otp-auth/enroll/invite/',
    },
}

const mutations = {}

const actions = {
    // Login step 2: verificar código TOTP tras login
    async verifyMFA({ state, getters, dispatch }, {code,  mfa_token, recovery_code }) {
        try {
            const resp = await axios.post(
                getters.getEndpointFromPath(state.paths.mfa),
                { code, mfa_token, recovery_code }
            )
            return resp.data
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                timeout: 8000,
                message: 'Código incorrecto o sesión expirada.',
            }, { root: true })
            throw error
        }
    },

    // Enrollment step 1: validar token del enlace y obtener URI del QR
    async enrollMFA({ state, getters, dispatch }, token) {
        try {
            const resp = await axios.get(
                getters.getEndpointFromPath(state.paths.enroll_token),
                { params: { token } }
            )
            return resp.data  // { valid, provisioning_uri, email }
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                timeout: 8000,
                message: 'El enlace ha expirado. Solicita uno nuevo a tu administrador.',
            }, { root: true })
            throw error
        }
    },

    // Enrollment step 2: confirmar primer código TOTP
    async confirmCode({ state, getters, dispatch }, { token, code }) {
        try {
            const resp = await axios.post(
                getters.getEndpointFromPath(state.paths.enroll_token),
                { token, code }
            )
            return resp.data  // { detail, recovery_codes }
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                timeout: 5000,
                message: error.response?.data?.detail || 'Código incorrecto.',
            }, { root: true })
            throw error
        }
    },
    async sendEnrollmentInvite({ state, getters, dispatch }, { email }) {
        try {
            const resp = await axios.post(
                getters.getEndpointFromPath(state.paths.enroll_invite),
                { email }
            )
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                timeout: 5000,
                message: `Enlace de enrolamiento enviado a ${email}.`,
            }, { root: true })
            return resp.data
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                timeout: 5000,
                message: 'Error al enviar el enlace. Inténtalo de nuevo.',
            }, { root: true })
            throw error
        }
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}